import { useTrackerAuth } from "components/AuthProvider";
import { Company } from "prisma/cm/client";

import { BENCHMARK_DATASET } from "../constants/enums";

export function useAuthorizedDataSets() {
  const { user } = useTrackerAuth();

  const datasets: Record<BENCHMARK_DATASET, boolean> = {
    comprehensive: false,
    comptryx: false,
    mercer: false,
    carta: false,
  };

  if (!user || user.role !== "COMPANY_ADMIN") {
    return datasets;
  }

  datasets.comprehensive = true;

  const company = user.company as Company;

  if (company.enableAdminComptryxBenchmarking) {
    datasets.comptryx = true;
  }

  if (company.enableAdminMercerBenchmarking) {
    datasets.mercer = true;
  }

  return datasets;
}
